import { useMemo } from 'react';

interface CacheResult<K, V> {
  getValue: (key: K) => V;
  delete: (key: K) => void;
  clear: () => void;
}

const useCache = <K, V>(createValue: (key: K) => V): CacheResult<K, V> => {
  return useMemo(() => {
    const cache = new Map<K, V>();

    const getValue = (key: K) => {
      let value = cache.get(key);

      if (value) {
        return value;
      }

      value = createValue(key);
      cache.set(key, value);
      return value;
    };

    const deleteValue = (key: K) => {
      cache.delete(key);
    };

    const clear = () => cache.clear();

    return { getValue, delete: deleteValue, clear };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useCache;
